/**
 * Sort an array of Moment date objects
 * @param {Array} dates
 * @return {Array}
 */
export const sortDates = dates =>
  dates.sort((a, b) => a.valueOf() - b.valueOf())
